export default {
  root: {
    letterSpacing: '2px',
    fontSize: '0.75em',
  },
}
